export default __webpack_public_path__ + "static/media/line-h-12.87d3535f.png";